'use client';

import * as React from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { TableCell, TableRow } from '@/components/ui/table';

interface FunnelsTableSkeletonProps {
  rows?: number;
}

/**
 * Skeleton loader for funnels table. Columns must mirror the order in
 * `funnels-table-columns.tsx`:
 *   select → name → status → isDefault → stepsCount → createdAt → updatedAt → id → actions
 */
export function FunnelsTableSkeleton({ rows = 8 }: FunnelsTableSkeletonProps) {
  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <TableRow key={i}>
          {/* Checkbox */}
          <TableCell>
            <Skeleton className="h-4 w-4" />
          </TableCell>
          {/* Funnel Name */}
          <TableCell>
            <div className="flex items-center gap-3">
              <Skeleton className="h-10 w-10 rounded-lg" />
              <div className="flex-1 space-y-2">
                <Skeleton className="h-4 w-[200px]" />
                <Skeleton className="h-3 w-[300px]" />
              </div>
            </div>
          </TableCell>
          {/* Status */}
          <TableCell>
            <Skeleton className="h-5 w-16" />
          </TableCell>
          {/* Default */}
          <TableCell>
            <Skeleton className="h-5 w-16" />
          </TableCell>
          {/* Steps Count */}
          <TableCell>
            <Skeleton className="h-4 w-24" />
          </TableCell>
          {/* Created At */}
          <TableCell>
            <Skeleton className="h-4 w-24" />
          </TableCell>
          {/* Updated At */}
          <TableCell>
            <Skeleton className="h-4 w-24" />
          </TableCell>
          {/* Funnel ID (copyable) */}
          <TableCell>
            <Skeleton className="h-5 w-20" />
          </TableCell>
          {/* Actions */}
          <TableCell>
            <Skeleton className="h-8 w-8 rounded" />
          </TableCell>
        </TableRow>
      ))}
    </>
  );
}
